angular.module('impactx.disposition').controller('DispositionUserTemplateListCtrl', [
    'selectedListItems',
    DispositionUserTemplateListCtrl
]);

function DispositionUserTemplateListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'HandleDispositionTemplate'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/disposition/templates/dispositionusertemplatelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/disposition/user/list',
        id: 'dispositionusertemplatelist',
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "basket/" + selectedListItems.getSelectedIdsWithTypes()[0].id;
    }
}